<template src="./index.html"></template>

<script>
import minhead from '../../../../common/minHead/index.vue';
import { getdata } from './data.js';
export default {
	components: {
		minhead
	},
	props: {
		headData:{
			type: Array,
			default:[]
		},
		tableData: {
			type: Array,
			default:[],
		},
		mxparams: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			// headData:getdata().headData,
			isbianj: false,
			tablekey:0,
		};
	},
	created() {
		this.headData=this.headData.map(item=>{
			item.headcustom=false
			return item
			})
		this.$nextTick(()=>{
		})
	},
	mounted() {},
	methods: {
		inputblur(e,code,prop){
			this.$emit('inputblur',e,code,prop)
		},
		isbjbcdj() {
			if(this.isbianj){
				this.$emit('preservations',this.tableData)
			}
			this.isbianj = !this.isbianj;
		},
		forback() {
			this.$emit('forback', '');
		}
	}
};
</script>

<style scoped lang="less">
@import url('index.less');
</style>
